import _extends from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/extends";
import React, { useEffect } from 'react';
import { handleFeedback } from '../../utils/helpers';
import { jsx as _jsx } from "react/jsx-runtime";

var FeedbackHandler = function FeedbackHandler(_ref) {
  var props = _extends({}, _ref);

  var authErrors = props.authErrors,
      prospectErrors = props.prospectErrors,
      providerErrors = props.providerErrors,
      sessionErrors = props.sessionErrors,
      analyticsErrors = props.analyticsErrors,
      bookingErrors = props.bookingErrors,
      paymentErrors = props.paymentErrors,
      authInfo = props.authInfo,
      serviceCustomerInfo = props.serviceCustomerInfo,
      serviceCustomerErrors = props.serviceCustomerErrors,
      assetsErrors = props.assetsErrors,
      subscriptionErrors = props.subscriptionErrors,
      reviewError = props.reviewError,
      prospectInfo = props.prospectInfo,
      providerInfo = props.providerInfo,
      sessionInfo = props.sessionInfo,
      bookingInfo = props.bookingInfo,
      analyticsInfo = props.analyticsInfo,
      paymentInfo = props.paymentInfo,
      subscriptionInfo = props.subscriptionInfo,
      reviewInfo = props.reviewInfo,
      clearAuthInfo = props.clearAuthInfo,
      clearServiceCustomerInfo = props.clearServiceCustomerInfo,
      clearProspectInfo = props.clearProspectInfo,
      clearProviderInfo = props.clearProviderInfo,
      clearSessionInfo = props.clearSessionInfo,
      clearBookingInfo = props.clearBookingInfo,
      clearAnalyticsInfo = props.clearAnalyticsInfo,
      clearPaymentInfo = props.clearPaymentInfo,
      clearSubscriptionInfo = props.clearSubscriptionInfo,
      clearReviewInfo = props.clearReviewInfo,
      clearAuthErrors = props.clearAuthErrors,
      clearProspectErrors = props.clearProspectErrors,
      clearProviderErrors = props.clearProviderErrors,
      clearServiceCustomerErrors = props.clearServiceCustomerErrors,
      clearSessionErrors = props.clearSessionErrors,
      clearAnalyticsErrors = props.clearAnalyticsErrors,
      clearBookingErrors = props.clearBookingErrors,
      clearPaymentErrors = props.clearPaymentErrors,
      clearAssetsErrors = props.clearAssetsErrors,
      clearSubscriptionErrors = props.clearSubscriptionErrors,
      clearReviewErrors = props.clearReviewErrors;
  var errorMappings = [{
    errors: authErrors,
    clearDispatch: clearAuthErrors
  }, {
    errors: prospectErrors,
    clearDispatch: clearProspectErrors
  }, {
    errors: providerErrors,
    clearDispatch: clearProviderErrors
  }, {
    errors: sessionErrors,
    clearDispatch: clearSessionErrors
  }, {
    errors: analyticsErrors,
    clearDispatch: clearAnalyticsErrors
  }, {
    errors: bookingErrors,
    clearDispatch: clearBookingErrors
  }, {
    errors: paymentErrors,
    clearDispatch: clearPaymentErrors
  }, {
    errors: serviceCustomerErrors,
    clearDispatch: clearServiceCustomerErrors
  }, {
    errors: assetsErrors,
    clearDispatch: clearAssetsErrors
  }, {
    errors: subscriptionErrors,
    clearDispatch: clearSubscriptionErrors
  }, {
    errors: reviewError,
    clearDispatch: clearReviewErrors
  }];
  var infoMappings = [{
    info: authInfo,
    clearDispatch: clearAuthInfo
  }, {
    info: serviceCustomerInfo,
    clearDispatch: clearServiceCustomerInfo
  }, {
    info: prospectInfo,
    clearDispatch: clearProspectInfo
  }, {
    info: providerInfo,
    clearDispatch: clearProviderInfo
  }, {
    info: sessionInfo,
    clearDispatch: clearSessionInfo
  }, {
    info: bookingInfo,
    clearDispatch: clearBookingInfo
  }, {
    info: analyticsInfo,
    clearDispatch: clearAnalyticsInfo
  }, {
    info: paymentInfo,
    clearDispatch: clearPaymentInfo
  }, {
    info: subscriptionInfo,
    clearDispatch: clearSubscriptionInfo
  }, {
    info: reviewInfo,
    clearDispatch: clearReviewInfo
  }];
  useEffect(function () {
    var errorMessageLookup = {};
    var infoMessageLookup = {};
    errorMappings.forEach(function (error) {
      if (errorMessageLookup[error.errors]) {
        return;
      }

      handleFeedback(error.errors, '');
      errorMessageLookup[error.errors] = true;
      error.clearDispatch();
    });
    infoMappings.forEach(function (info) {
      if (infoMessageLookup[info.info]) {
        return;
      }

      handleFeedback('', info.info);
      infoMessageLookup[info.info] = true;
      info.clearDispatch();
    });
  }, [errorMappings, infoMappings]);
  return /*#__PURE__*/_jsx("div", {
    className: "h-fill",
    children: props.children
  });
};

export default FeedbackHandler;